define('model/ReviewModel',['require','lib/model/BaseModel','lib/validator/ValidatorNotEmpty','lib/validator/ValidatorInterval'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var ValidatorNotEmpty = require('lib/validator/ValidatorNotEmpty');
    var ValidatorReviewRate = require('lib/validator/ValidatorInterval');

    /**
     * Reviews data model
     *
     * @class ReviewsModel
     */
    return BaseModel.extend({

        urlRoot: '/review/list/id/',

        defaults: {
            id: null,
            feedback_datetime: '',
            name: '',
            link: '',
            image: '',
            subject: '',
            message: '',
            provider: '',
            status: '',
            feedback_link: '',
            likes : 0,
            rate: 5
        },

        initialize: function () {
            this.validators = {
                'subject': [new ValidatorNotEmpty()],
                'message': [new ValidatorNotEmpty()],
                'rate': [
                    new ValidatorNotEmpty(),
                    new ValidatorReviewRate({
                        min : 1,
                        max : 5,
                        error : 'error_review_rate_is_not_valid'
                    })
                ]
            };

            BaseModel.prototype.initialize.call(this);
        },
        
        likeReview : function () {
            this._saveLike('like');
        },
        
        dislikeReview : function () {
            this._saveLike('dislike');
        },

        _saveLike : function (type) {
            if(type === this.get('like_type')){
                this.set('like_type', null); //remove like or dislike
            } else {
                this.set('like_type', type);
            }

            this.save(null, {
                success: _.bind(function () {
                    Backbone.Wreqr.radio.vent.trigger('event', 'review:saved');
                }, this)
            });
        }

    });

});
